export default {
  locale: "es",
  name: "CancellationPoliciesconfiguration",
  translation: { displayName: "Translations" },
  fields: {
    /** Here are te entities used in the lists, Order is important */
    /** fieldName: this is used like the id container of the properties */
    /** displayName: this is the title rendered */
    list: [
      //columns to be used in the table/list display, Order IS important
      {
        fieldName: "cancelOnline",
        displayName: "Cancelar online",
        helpText: "Habilita la cancelación online por parte del huésped",
      },
      {
        fieldName: "maxRelease",
        displayName: "Desde",
        widget: "daysRenderer",
      },
      {
        fieldName: "minRelease",
        displayName: "Hasta",
        widget: "daysRenderer",
      },
      {
        fieldName: "type",
        displayName: "Tipo de penalización",
        widget: "arrayPropertyRenderer",
        searchCriteria: "type",
        fieldSelector: {
          FIX_AMOUNT: "Cantidad Fija",
          PERCENTAGE: "Porcentaje",
          CHARGE_FIRST_NIGHT: "Primera noche",
        },
      },
    ],
    /** Here is the entity used in the forms, Order is important */
    /** all the properties can be found in app/components/CRUD/Common, at the corresponding js file */
    /** fieldName: is like the id in html, it must be unique among the attributes */
    /** widget: is used to render the kind of interaction the user will have, a complete list can be found in component/CRUD/Common */
    /** displayName: The text that introduces the widget */
    /** defaultValue: The default value of the widget */
    /** optionDisplay: An object that containes objects with the option at the select */
    form: [
      //fields to be used in the creation/edit form display, Order IS important
      {
        fieldName: "cancelOnline",
        displayName: "Cancelar online",
        widget: "checkbox",
      },
      {
        fieldName: "maxRelease",
        displayName: "Inicio del periodo de penalización",
        widget: "cancellationRange",
        helpText: "Define dia y hora de inicio de esta penalización (respecto al dia de checkin).",
        defaultValue: "undefined",
        optionDisplayFirst: {
          undefined: { label: "Sin límite" },
          "0": { label: "Mismo dia del checkin" },
          "1": { label: "1 dias antes checkin" },
          "2": { label: "2 dias antes checkin" },
          "3": { label: "3 dias antes checkin" },
          "4": { label: "4 dias antes checkin" },
          "5": { label: "5 dias antes checkin" },
          "6": { label: "6 dias antes checkin" },
          "7": { label: "7 dias antes checkin" },
          "8": { label: "8 dias antes checkin" },
          "9": { label: "9 dias antes checkin" },
          "10": { label: "10 dias antes checkin" },
          "11": { label: "11 dias antes checkin" },
          "12": { label: "12 dias antes checkin" },
          "13": { label: "13 dias antes checkin" },
          "14": { label: "14 dias antes checkin" },
          "15": { label: "15 dias antes checkin" },
          "16": { label: "16 dias antes checkin" },
          "17": { label: "17 dias antes checkin" },
          "18": { label: "18 dias antes checkin" },
          "19": { label: "19 dias antes checkin" },
          "20": { label: "20 dias antes checkin" },
          "21": { label: "21 dias antes checkin" },
          "22": { label: "22 dias antes checkin" },
          "23": { label: "23 dias antes checkin" },
          "24": { label: "24 dias antes checkin" },
          "25": { label: "25 dias antes checkin" },
          "26": { label: "26 dias antes checkin" },
          "27": { label: "27 dias antes checkin" },
          "28": { label: "28 dias antes checkin" },
          "29": { label: "29 dias antes checkin" },
          "30": { label: "30 dias antes checkin" },
          "35": { label: "35 dias antes de checkin" },
          "40": { label: "40 dias antes de checkin" },
          "45": { label: "45 dias antes de checkin" },
          "50": { label: "50 dias antes de checkin" },
          "55": { label: "55 dias antes de checkin" },
          "60": { label: "60 dias antes checkin" },
          "90": { label: "90 dias antes checkin" },
          "120": { label: "120 dias antes checkin" },
          "150": { label: "150 dias antes checkin" },
          "180": { label: "180 dias antes checkin" },
          "210": { label: "210 dias antes checkin" },
          "240": { label: "240 dias antes checkin" },
          "270": { label: "270 dias antes checkin" },
          "300": { label: "300 dias antes checkin" },
          "330": { label: "330 dias antes checkin" },
          "360": { label: "360 dias antes checkin" },
        },
        optionDisplaySecond: {
          "00:01": { label: "0:01" },
          "01:00": { label: "1:00" },
          "02:00": { label: "2:00" },
          "03:00": { label: "3:00" },
          "04:00": { label: "4:00" },
          "05:00": { label: "5:00" },
          "06:00": { label: "6:00" },
          "07:00": { label: "7:00" },
          "08:00": { label: "8:00" },
          "09:00": { label: "9:00" },
          "10:00": { label: "10:00" },
          "11:00": { label: "11:00" },
          "12:00": { label: "12:00" },
          "13:00": { label: "13:00" },
          "14:00": { label: "14:00" },
          "15:00": { label: "15:00" },
          "16:00": { label: "16:00" },
          "17:00": { label: "17:00" },
          "18:00": { label: "18:00" },
          "19:00": { label: "19:00" },
          "20:00": { label: "20:00" },
          "21:00": { label: "21:00" },
          "22:00": { label: "22:00" },
          "23:00": { label: "23:00" },
          "23:59": { label: "23:59" },
        },
      },
      //Add another field with reduced options and consider both onsubmit?
      {
        fieldName: "minRelease",
        displayName: "Fin del periodo de penalización",
        widget: "cancellationRange",
        helpText: "Define dia y hora de fin de esta penalización (respecto al dia de checkin).",
        defaultValue: "undefined",
        optionDisplayFirst: {
          undefined: { label: "Sin límite" },
          "0": { label: "Mismo dia del checkin" },
          "1": { label: "1 dias antes checkin" },
          "2": { label: "2 dias antes checkin" },
          "3": { label: "3 dias antes checkin" },
          "4": { label: "4 dias antes checkin" },
          "5": { label: "5 dias antes checkin" },
          "6": { label: "6 dias antes checkin" },
          "7": { label: "7 dias antes checkin" },
          "8": { label: "8 dias antes checkin" },
          "9": { label: "9 dias antes checkin" },
          "10": { label: "10 dias antes checkin" },
          "11": { label: "11 dias antes checkin" },
          "12": { label: "12 dias antes checkin" },
          "13": { label: "13 dias antes checkin" },
          "14": { label: "14 dias antes checkin" },
          "15": { label: "15 dias antes checkin" },
          "16": { label: "16 dias antes checkin" },
          "17": { label: "17 dias antes checkin" },
          "18": { label: "18 dias antes checkin" },
          "19": { label: "19 dias antes checkin" },
          "20": { label: "20 dias antes checkin" },
          "21": { label: "21 dias antes checkin" },
          "22": { label: "22 dias antes checkin" },
          "23": { label: "23 dias antes checkin" },
          "24": { label: "24 dias antes checkin" },
          "25": { label: "25 dias antes checkin" },
          "26": { label: "26 dias antes checkin" },
          "27": { label: "27 dias antes checkin" },
          "28": { label: "28 dias antes checkin" },
          "29": { label: "29 dias antes checkin" },
          "30": { label: "30 dias antes checkin" },
          "35": { label: "35 dias antes checkin" },
          "40": { label: "40 dias antes checkin" },
          "45": { label: "45 dias antes checkin" },
          "50": { label: "50 dias antes checkin" },
          "55": { label: "55 dias antes checkin" },
          "60": { label: "60 dias antes checkin" },
          "90": { label: "90 dias antes checkin" },
          "120": { label: "120 dias antes checkin" },
          "150": { label: "150 dias antes checkin" },
          "180": { label: "180 dias antes checkin" },
          "210": { label: "210 dias antes checkin" },
          "240": { label: "240 dias antes checkin" },
          "270": { label: "270 dias antes checkin" },
          "300": { label: "300 dias antes checkin" },
          "330": { label: "330 dias antes checkin" },
          "360": { label: "360 dias antes checkin" },
        },
        optionDisplaySecond: {
          "00:01": { label: "0:01" },
          "01:00": { label: "1:00" },
          "02:00": { label: "2:00" },
          "03:00": { label: "3:00" },
          "04:00": { label: "4:00" },
          "05:00": { label: "5:00" },
          "06:00": { label: "6:00" },
          "07:00": { label: "7:00" },
          "08:00": { label: "8:00" },
          "09:00": { label: "9:00" },
          "10:00": { label: "10:00" },
          "11:00": { label: "11:00" },
          "12:00": { label: "12:00" },
          "13:00": { label: "13:00" },
          "14:00": { label: "14:00" },
          "15:00": { label: "15:00" },
          "16:00": { label: "16:00" },
          "17:00": { label: "17:00" },
          "18:00": { label: "18:00" },
          "19:00": { label: "19:00" },
          "20:00": { label: "20:00" },
          "21:00": { label: "21:00" },
          "22:00": { label: "22:00" },
          "23:00": { label: "23:00" },
          "23:59": { label: "23:59" },
        },
      },
      {
        fieldName: "type",
        displayName: "Tipo de penalización",
        widget: "selector",
        optionDisplay: {
          FIX_AMOUNT: {
            label: "Cantidad Fija",
          },
          PERCENTAGE: {
            label: "Porcentaje",
          },
          CHARGE_FIRST_NIGHT: {
            label: "Primera noche",
          },
        },
        defaultValue: "FIX_AMOUNT",
      },
      {
        fieldName: "penalty",
        displayName: "Cantidad",
        widget: "input",
      },
    ],
  },
  validation: {
    maxRelease: {
      constraints: {
        compare: {
          message: "^Antelación máxima debe ser mayor que la antelación mínima.",
        },
      },
    },
    "minRelease.days": {
      constraints: {
        compare: {
          message: "^Antelación máxima debe ser mayor que la antelación mínima.",
        },
      },
    },
  },
};
